import { useLayoutEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { resolveLanguage } from './language'

export function useSyncLanguage(apiLanguage: string | null | undefined) {
  const { i18n } = useTranslation()
  const resolved = resolveLanguage({
    apiLanguage,
    browserLocale: typeof navigator !== 'undefined' ? navigator.language : 'en',
  })

  useLayoutEffect(() => {
    if (i18n.language !== resolved) {
      void i18n.changeLanguage(resolved)
    }
    if (document.documentElement.lang !== resolved) {
      document.documentElement.lang = resolved
    }
  }, [i18n, resolved])
}
